import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { ConnectedUserContext } from '../connectedUser-context';

// ref: https://developer.paypal.com/docs/classic/paypal-payments-standard/integration-guide/Appx_websitestandard_htmlvariables/#technical-variables
const sandbox = false;

/** Production Postback URL */
const PRODUCTION_VERIFY_URI = 'https://www.paypal.com/cgi-bin/webscr';
const PRODUCTION_BUSINESS = 'patrick.poulin@gmail.com';

/** Sandbox Postback URL */
const SANDBOX_VERIFY_URI = 'http://www.sandbox.paypal.com/cgi-bin/webscr';
const SANDBOX_BUSINESS = 'patrick.poulin-facilitator@gmail.com';
// paypal sandbox client: patrick.poulin-buyer@gmail.com
// all same password then regular paypal account

const LOCALHOST_URL_PREFIX = 'http://localhost:3002/';
const PRODUCTION_URL_PREFIX = 'http://statelo.com/';

const RETURN_URL = 'userAccount';
const CANCEL_RETURN_URL = 'userAccount';
const IPN_LISTENER_URL = 'api/ipnpaypal';

class UserAccount extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);
		this.state = {
			expDelay: 0,
			showSubscriptionPanel: false,
			showMemberPanel: true,		// default true
			urlPrefix: '',
			reference: ''
		};
	
		this.clickSaveInsc = this.clickSaveInsc.bind(this);
		this.clickSaveInsc01 = this.clickSaveInsc01.bind(this);
		this.clickSaveInsc02 = this.clickSaveInsc02.bind(this);
	}

  componentDidMount() {
    //console.log('USER-ACCOUNT: componentDidMount');
    const urlPrefix = window.location.href.includes('localhost') ? LOCALHOST_URL_PREFIX : PRODUCTION_URL_PREFIX;
    this.setState({ urlPrefix });
	}

	render() {
		// console.log('USER-ACCOUNT: render')
		// console.log(this.context.connectedUser)

		return (
			<div className="animated fadeIn">
				{this.displayModule()}
			</div>
		);
	}
	
	displayModule() {
		const { connectedUser } = this.context;
		const user = connectedUser?.user || null;

		console.log("user", user);

    if (!connectedUser) {
			return (
				<div>
		      <h5>Votre Compte</h5>
					<p>Vous devez vous connecter pour visualiser votre compte ou vous abonner.<br/>
					Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
				</div>
			);
		} else if (!user) {
      return (
        <div>
          <div className="row">
            <div className="col-6">
              <h5>Votre Compte</h5>
              <h5>Chargement…</h5>
            </div>
          </div>
          <hr/>
        </div>
      );
	  } else {
			return (
				<div>
				<div className="row">
					<div className="col-6">
		        <h5>Votre Compte</h5>
						<h5>{user.name}</h5>
					</div>
	       </div>
				<hr/>

				<div className="row">
				<div className="col-md-12">
					{this.displayData(user)}
				</div>
				</div>
				</div>
			)
		}
	}

	// https://www.w3schools.com/tags/att_form_autocomplete.asp
	// https://developers.google.com/web/fundamentals/design-and-ux/input/forms/#recommended_input_name_and_autocomplete_attribute_values
	displayData(user) {
		return (
			<div className="row">
				<div className="col-md-4">
					<h5>Informations utilisateur</h5><br/>
					<p>Nom: {user.name}</p>
					<p>Adresse: {user.streetaddress}</p>
					<p>Ville: {user.addresslevel2}</p>
					<p>Province / État: {user.addresslevel1}</p>
					<p>Code postal: {user.postalcode}</p>
					<p>Pays: {user.country}</p>
					<p>Courriel: {user.email}</p>
					<p>Téléphone: {user.tel}</p>
					<p><b>Profil de joueur: {user.playerName}</b></p>
					<Link to='/profile' className="btn btn-primary"> Modifier votre profil </Link>
					<hr/>
				</div>

				<div className="col-md-8">
					{this.state.showMemberPanel ? this.dispMemberPanel(user) : null}
				</div>
				<br/>
			</div>
		);
	}

	dispMemberPanel(user) {
		return (
			<div className="row">
			<div className="col-md-12">
				<h5>Abonnement au Tableau de Bord</h5><br/>
				{user.memberActive ? this.dispMemberDiv(user) : this.dispNonMemberDiv(user)}
			</div>
			</div>				
		);
	}

	dispMemberDiv(user) {
		var expDelayClassStr = '';
		if (user.expDelay <= 14) {
			expDelayClassStr = 'exp-delay-expiring';
		}

		return (
			<div className="form-group">
				<div className="row">
				<div className="col-md-8 text-center">
					<p className="form-control member-box member-active" id="memberActive"> Vous êtes membre ! </p>
				</div>
				</div>
					
				<div className="row">
				<div className="col-md-12">
					<br/>
					<span className={expDelayClassStr}> Expiration de votre abonnement: {moment(user.memberDateExpiration).format('YYYY-MM-DD')} </span> <br/>
					<span className={"font-italic " + expDelayClassStr}> (Jours restants: {user.expDelay}) </span>
				</div>
				</div>
				<br/>

				{this.dispRenew(user)}
			</div>
		);
	}

	dispNonMemberDiv(user) {
		return (
			<div className="form-group">
				<div className="row">
				<div className="col-md-8 text-center">
					<p className="form-control member-box member-inactive" id="memberActive"> Vous n'êtes pas membre &nbsp;:-( </p>
				</div>
				</div>
  			<br/>

				<div className="row">
				<div className="col-md-12">
					<p> Abonnez-vous simplement et profitez de statistiques avancées très intéressantes ! </p>
					<img className="img-fluid" src="./img/regulier-aut-2019-banner.png" alt="abonnement-annuel" width="600"/>
   				<br/><br/>
				</div>
				</div>

				{this.dispSubsPanel(user)}

			</div>
		);
	}

	dispRenew(user) {
		if (true) {
			return(
				<div className="row">
				<div className="col-md-12">

					<p> Renouveller votre abonnement avant qu'il expire. Ce dernier s'ajoutera à votre période actuelle. </p>
					<img className="img-fluid" src="./img/regulier-aut-2019-banner.png" alt="abonnement-annuel" width="600"/>
	    		<br/><br/>
					{this.dispSubsPanel(user)}

				</div>
				</div>
			);

		} else {
			return(
				<div className="row">
				<div className="col-md-12">
					<br/>
					<p> Renouvellement possible lorsqu'il reste 90 jours et moins à votre abonnement.</p>
				</div>
				</div>
			);
		}
	}

	dispSubsPanel(user) {
		const { urlPrefix } = this.state;
		const userId = user?.auth0_user_id || user?.user_id || user?.id || '';

		return (
			<div className="row">
			<div className="col-md-12">

				<p>Cliquer sur le bouton suivant pour payer par PayPal ou carte de crédit</p>

				<form action={sandbox ? SANDBOX_VERIFY_URI : PRODUCTION_VERIFY_URI} method='post'>
			    <input type='hidden' name='cmd' value='_xclick'/>
			    <input type='hidden' name='business' value={sandbox ? SANDBOX_BUSINESS : PRODUCTION_BUSINESS}/>
			    <input type='hidden' name='quantity' value='1'/>
			    <input type='hidden' name='item_name' value='Abonnement 12 mois - Régulier'/>
			    <input type='hidden' name='amount' value='49.00'/>
			    <input type='hidden' name='currency_code' value='CAD'/>
			    <input type='hidden' name='item_number' value='AB12M-01R'/>
			    <input type='hidden' name='no_shipping' value='1'/>
			    <input type="hidden" name="lc" value="fr_CA"/>
			    <input type='hidden' name='custom' value={userId}/>
			    <input type='hidden' name='return' value={urlPrefix + RETURN_URL}/>
			    <input type='hidden' name='cancel_return' value={urlPrefix + CANCEL_RETURN_URL}/>
			    <input type='hidden' name='notify_url' value={urlPrefix + IPN_LISTENER_URL}/>                       

  				<button type="submit" className="btn btn-primary" onClick={this.clickSaveInsc02}> Payer avec Paypal ou une carte de crédit</button>
				</form> 
			</div>
			</div>
		);
	}

	clickSaveInsc01() {
		this.clickSaveInsc(0);
	}

	clickSaveInsc02() {
		this.clickSaveInsc(1);
	}

	clickSaveInsc(txType) {
		const { reference } = this.state;
		const ctxUser = this.context.connectedUser?.user || {};
		const userId = ctxUser.auth0_user_id || ctxUser.user_id || ctxUser.id || '';
		const userName = ctxUser.name || '';

		// const userId = user.auth0_user_id;
		// const userName = user.name;
		var typeStr = '';

		if(txType === 0) {
			typeStr = 'Click: Abonnement mensuel';
		} else if (txType === 1) {
			typeStr = 'Click: Abonnement annuel';
		}

		// Log Events from user
		var userEventsObj = {
			date: new Date(),
			type: 'ClickPay',
			userId: userId,
			typeStr: typeStr,
			userName: userName,
			reference: reference,
			sandbox: sandbox
		};

		Axios.post('/api/userEvents/logEvent/', {
			userEventsObj: userEventsObj
		})
		.then(response => {
			//console.log(response);
		})
		.catch(error => {
			console.log(error);
		});
	}

}

export default UserAccount;

